import { React, useState, useEffect, useContext } from "react";
import "./../styles/QueueContent.css";
import "./../styles/Tabs.css";
import { Button } from "./Button";
import { BasicTable } from "./Tables";
import { Link, useHistory } from "react-router-dom";
import { ApiCall } from "../../utility/ApiCalls";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import PersonIcon from "@mui/icons-material/Person";
import AutoProcessedDialog from "../userHome/AutoProcessedDialog";
import { Box } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ClearIcon from "@mui/icons-material/Clear";
import Api_Call from "../../ApiCall";
import ErrorPage from "../Common/ErrorPage";
import UserContext from "../Common/UserContext";
import menus from "../../user-config.json";
import NoteIcon from "@mui/icons-material/Note";
import LetterPopUp from "../userHome/LetterPopUp";
import CustomModal from "./AuditModalBox";

export const QueueContent = (props) => {
  console.log("---------------Queue content rendered------------------");
  const history = useHistory();
  const taskBtn = props.taskBtn;
  const completedListFlag = props.completedListFlag;
  const [loader, setLoader] = useState(false);
  const [caseactivityData, setCaseactivityData] = useState([]);
  const [lettersData, setlettersData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [isLettersOpen, setLettersOpen] = useState(false);
  const [
    activeTaskIdAfterLetterIconclick,
    setActiveTaskIdAfterLetterIconclick,
  ] = useState("");
  const [isPdfVisible, setIsPdfVisible] = useState(false);
  const [isCrossClickedOnLetterPopup, setIsCrossClickedOnLetterPopup] =
    useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [letterUrl, setLetterUrl] = useState();
  const { userRole } = useContext(UserContext);

  useEffect(() => {
    if (isCrossClickedOnLetterPopup) setLettersOpen(true);
  }, [isCrossClickedOnLetterPopup]);

  console.log(
    `USeEffect running-->
    isCrossClickedOnLetterPopup ${isCrossClickedOnLetterPopup},
    isLettersOpen ${isLettersOpen}`
  );
  var colums = [
    completedListFlag && {
      width: 20,
      Header: "",
      accessor: "AutoProcessed",
      Cell: (props) => {
        return (
          <>
            {
              <div>
                {props.row.values.AutoProcessed == 1 ? (
                  <span
                    className="link"
                    onClick={() => autoProcess(props.row.values.Task_ID)}
                  >
                    <PrecisionManufacturingIcon />
                  </span>
                ) : (
                  <span
                    className="link"
                    onClick={() => autoProcess(props.row.values.Task_ID)}
                  >
                    <PersonIcon />
                  </span>
                )}
              </div>
            }
          </>
        );
      },
    },
    {
      width: 100,
      Header: "Task ID",
      accessor: "Task_ID",
      Cell: (props) => {
        return (
          <>
            {taskBtn ? (
              props.row.values.Task_ID
            ) : (
              <span className="link" onClick={startPendingTask}>
                {props.row.values.Task_ID}
              </span>
            )}
          </>
        );
      },
    },
    {
      width: 100,
      Header: "Priority",
      accessor: "Priority",
    },
    {
      width: 150,
      Header: "Member ID",
      accessor: "MemberID_CR",
    },
    {
      width: 150,
      Header: "Member Name",
      accessor: "MemberName",
    },
    completedListFlag
      ? ""
      : {
          width: 150,
          // Header: "Extraction Confidence",
          Header: "Completion Status",
          accessor: "ConfidenceScore",
        },
    completedListFlag
      ? ""
      : {
          width: 150,
          Header: "Extraction",
          accessor: "Extraction",
          Cell: (props) => {
            return (
              <>
                {props.row.values.Extraction == "0" ? (
                  <MoreHorizIcon />
                ) : props.row.values.Extraction == "1" ? (
                  <CheckIcon />
                ) : props.row.values.Extraction == "2" ? (
                  <ClearIcon />
                ) : (
                  ""
                )}
              </>
            );
          },
        },
    completedListFlag
      ? ""
      : {
          width: 250,
          Header: "Business Validation",
          accessor: "Validation",
          Cell: (props) => {
            return (
              <>
                {props.row.values.Validation == "0" ? (
                  <MoreHorizIcon />
                ) : props.row.values.Validation == "1" ? (
                  <CheckIcon />
                ) : props.row.values.Validation == "2" ? (
                  <ClearIcon />
                ) : (
                  ""
                )}
              </>
            );
          },
        },
    {
      width: 150,
      Header: "Turn Around Time",
      accessor: "tat",
    },
    completedListFlag && {
      width: 150,
      Header: "Auth ID",
      accessor: "AuthID",
      Cell: (props) => {
        return <>{<div>{props.row.values.AuthID}</div>}</>;
      },
    },
    completedListFlag && {
      width: 150,
      Header: "Case Result",
      accessor: "Status",
      Cell: (props) => {
        return <>{<div>{props.row.values.Status}</div>}</>;
      },
    },
    completedListFlag && {
      width: 92,
      Header: "Case Created at",
      accessor: "TaskCreateDate_DT",
      Cell: (props) => {
        return <>{<div>{props.row.values.TaskCreateDate_DT}</div>}</>;
      },
    },
    completedListFlag && {
      width: 150,
      Header: "Data Extracted",
      accessor: "Extraction_Completed",
      Cell: (props) => {
        return <>{<div>{props.row.values.Extraction_Completed}</div>}</>;
      },
    },
    completedListFlag && {
      width: 150,
      Header: "Validation Completed",
      accessor: "Validation_Completed",
      Cell: (props) => {
        return <>{<div>{props.row.values.Validation_Completed}</div>}</>;
      },
    },
    completedListFlag && {
      width: 150,
      Header: "Case Completed at",
      accessor: "Case_Completed",
      Cell: (props) => {
        return <>{<div>{props.row.values.Case_Completed}</div>}</>;
      },
    },

    // (props.activeStyle.pending || props.activeStyle.completed) && {
    //   width: 150,
    //   Header: "View Letters",
    //   accessor: "",
    //   Cell: (props) => {
    //     return (
    //       <NoteIcon
    //         style={{ cursor: "pointer" }}
    //         onClick={() => {
    //           letterClickHandler(props.row.values.Task_ID);
    //           setActiveTaskIdAfterLetterIconclick(props.row.values.Task_ID);
    //         }}
    //       ></NoteIcon>
    //     );
    //   },
    // },
  ].filter((item) => item);

  var columsUser = [
    {
      width: 100,
      Header: "User ID",
      accessor: "User_ID",
    },
    {
      width: 250,
      Header: "First Name",
      accessor: "FirstName_CR",
    },
    {
      width: 250,
      Header: "Last Name",
      accessor: "LastName_CR",
    },
    {
      width: 200,
      Header: "Assigned",
      accessor: "Assigned",
    },
    {
      width: 200,
      Header: "Remaining",
      accessor: "Pending",
    },
    {
      width: 200,
      Header: "Completed",
      accessor: "Completed",
    },
    {
      width: 100,
      Header: "Active",
      accessor: "Active",
    },
    {
      width: 100,
      Header: "Pended",
      accessor: "Pended",
    },
  ];

  // const openModal = () => {
  //   setIsPdfVisible(true);
  //   setModalOpen(true);
  // };

  // const closeModal = () => {
  //   setModalOpen(false);
  // };

  // const letterClickHandler = async (taskId) => {
  //   setLettersOpen(true);
  //   setLoading(true);
  //   try {
  //     const api = new Api_Call();
  //     const data = await api.getData(
  //       `LETTERS/GENERATION?taskID=${taskId}&letter_id=`
  //     );
  //     console.log(data.body["letter_details"]);
  //     setlettersData(data.body["letter_details"]);
  //   } catch (error) {
  //     console.log("Error Occured");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  async function startTask() {
    try {
      setLoader(true);
      const api = new Api_Call();
      const data = await api.getData(
        "TASK/START_TASK?taskID=&module_name=intake"
      );
      if (data.statusCode != 200) {
        throw new Error("Fetching Data Failed");
      }
      console.log(data);

      sessionStorage.setItem("ActiveTaskID", data.body);
      var redirectPath = "/Verification";
      history.push(redirectPath);
    } catch (error) {
      console.error(error.message);
      setError(error);
    } finally {
      setLoader(false);
    }
  }

  async function startPendingTask(e) {
    console.log(e.currentTarget.textContent);
    try {
      setLoader(true);
      const api = new Api_Call();
      const data = await api.getData(
        `VALIDATIONS/GET-DATA?taskID=${
          e.currentTarget.textContent
        }&clinical_data=${menus[userRole.toLowerCase()].clinical}` // Vlaue can be 0 or 1;
      );

      if (data.statusCode != 200) {
        throw new Error("Fetching Data Failed");
      }
      console.log(data);
      sessionStorage.setItem("ActiveTaskID", data.body.Task_ID);
      var redirectPath = "/Verification";
      history.push(redirectPath);
    } catch (error) {
      console.error(error.message);
      setError(error);
    } finally {
      setLoader(false);
    }
  }

  async function autoProcessApi(taskId) {
    console.log(taskId);
    try {
      const api = new Api_Call();
      const data = await api.getData(`TASK/ACTIVITY-LOG?TaskID=${taskId}`);

      if (data.statusCode != 200) {
        throw new Error("Fetching Data Failed");
      }
      console.log(data);
      setCaseactivityData(data.body);
    } catch (error) {
      console.error(error.message);
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const autoProcess = (taskId) => {
    setOpen(true);
    autoProcessApi(taskId);
  };

  useEffect(() => {
    if (props.type === "supervisor" || props.type === "admin") {
      props.setAssigned(props.dataSupervisorAssigned.length);
      props.setUnassigned(props.dataSupervisorUnassigned.length);
    }
  }, []);

  if (error) {
    return <ErrorPage message={error.message} code={error.code} />;
  }

  return (
    <>
      <div className="content-main">
        <div className="user-content-container">
          {props.taskBtn ? (
            <div className="button-div">
              <Button
                buttonStyle="btn--primary"
                buttonSize="btn--medium"
                onClick={startTask}
              >
                Start Next Task
              </Button>
            </div>
          ) : (
            ""
          )}
          <Box className="tasklist-table">
            <BasicTable
              columns={colums}
              tableData={props.taskQueueData}
              tableType="default"
              AddButtonText=""
            ></BasicTable>
          </Box>
          <AutoProcessedDialog
            open={open}
            onClose={handleClose}
            caseactivityData={caseactivityData}
            isLoading={isLoading}
          />
          {/* <LetterPopUp
            open={isLettersOpen}
            onClose={() => setLettersOpen(false)}
            lettersData={lettersData}
            isLoading={isLoading}
            setLettersOpen={setLettersOpen}
            activeTaskId={activeTaskIdAfterLetterIconclick}
            setIsPdfVisible={setIsPdfVisible}
            setModalOpen={setModalOpen}
            setLetterUrl={setLetterUrl}
            setIsCrossClickedOnLetterPopup={setIsCrossClickedOnLetterPopup}
          ></LetterPopUp>

          {isPdfVisible && (
            <CustomModal
              isOpen={isModalOpen}
              onClose={closeModal}
              urlpdF={letterUrl}
              setLetterUrl={setLetterUrl}
              setIsCrossClicked={setIsCrossClickedOnLetterPopup}
            />
          )} */}
        </div>
      </div>
      {loader ? (
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
